import React from 'react';
import PropTypes from 'prop-types';

import Icon from '@Theme/hellofinance/components/Icon/Icon';

import * as styles from './Breadcrumbs.module.scss';

const propTypes = {
  /**
   * Breadcrumbs, array of objects: label and href
   */
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      href: PropTypes.string,
      title: PropTypes.string
    })
  ),

  isArticle: PropTypes.bool,

  icon: PropTypes.shape({
    path: PropTypes.string,
    viewBox: PropTypes.string
  }),

  /**
   * Additional classname
   */
  classname: PropTypes.string
};

const Breadcrumbs = ({
  items,
  classname,
  isArticle,
  icon
}) => {
  if (!items) {
    return false;
  }

  return <ol className={`${styles.root} ${classname || ''} ${isArticle ? styles.rootArticle : ''}`}>
    {items.map(({
      label,
      href,
      title
    }, index) => {
      const Component = href ? 'a' : 'span';

      return (
        <li key={index} className={styles.rootItem}>
          <Component
            href={href}
            title={title}
            className={href ? styles.rootLink : styles.rootSpan}>
            {index ? label : <Icon classname={styles.rootIcon} path={icon?.path} viewBox={icon?.viewBox}/>}
          </Component>
        </li>
      );
    })}
  </ol>;
};

Breadcrumbs.propTypes = propTypes;

export default Breadcrumbs;
